/**
 * adsApi — minimal client for the public ad-serving endpoints.
 * The click URL is server-handled (302 redirect to the campaign target),
 * so the consumer just opens it in a new tab.
 */
import { api } from './api';

export interface ServedAd {
  campaignId: number;
  creativeId: number;
  slot: 'feed_native' | 'sidebar_banner' | 'map_overlay';
  name: string;
  textCopy: string | null;
  mediaUrl: string | null;
  mediaKind: 'image' | 'video' | null;
  variant: string | null;
  clickUrl: string;
}

export const adsApi = {
  serve: (slot: ServedAd['slot'], opts: { lat?: number; lng?: number; zip?: string } = {}) => {
    const q = new URLSearchParams({ slot });
    if (opts.lat != null) q.set('lat', String(opts.lat));
    if (opts.lng != null) q.set('lon', String(opts.lng));
    if (opts.zip) q.set('zip', opts.zip);
    return api<{ ad: ServedAd | null; reason?: string }>(`/api/ads/serve?${q}`);
  },
};
